import React, { useEffect, useState } from 'react';
import { ActivityIndicator, ImageBackground, ScrollView, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { market_getOrderByOrderId, market_getPlayerFilterById, market_runPlayerFilter, market_saveOrderResponse, market_setDraftOrder } from '../../store/actionsv1/markets';
import { OrderProps, OrderResponseProps, PlayerFilterProps } from '../../store/types/mk_svc';
import PromotedOrderCard from '../Social/components/PromotedOrderCard';
import PromotedOrderToolbar from '../Social/components/PromotedOrderToolbar';

type BetMatchStateProps = {
    loading:boolean,
    viewing_player_id?:string
    promoted_order_index: number,
    height:number
}
const BetMatch = ({ navigation, route }:any) => {
    const [ bet_match_state, setBetMatch ] = useState<BetMatchStateProps>({
        loading: false,
        promoted_order_index:100000,
        height: 500
    });
    const { loading, promoted_order_index } = bet_match_state;

    //Redux
    const dispatch = useDispatch();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width === right.width)
    const filtered_orders:string[] = useSelector((state:any) => state.market.filtered_orders, (left, right) => left.length == right.length)
    const orders:OrderProps[] = useSelector((state:any) => state.market.orders, (left, right) => left.length == right.length)
    const promoted_order = orders.find(o => o.order_id == filtered_orders[promoted_order_index])
    const player_filter:PlayerFilterProps | undefined = useSelector((state:any) => state.market.player_filters.find(pf => pf.player_filter_id == route.params.player_filter_id), (left, right) => left?.player_filter_id == right?.player_filter_id)
    useEffect(() => {
        if(!route.params?.player_filter_id){ return }
        if(route.params?.order_id){
            getOrderFromServer(route.params.player_filter_id, route.params.order_id)
            return
        }
        runPlayerFilter(route.params.player_filter_id)
    },[route.params.player_filter_id])

    const getOrderFromServer = async(player_filter_id:string, order_id:string) => {
        setBetMatch({ ...bet_match_state, loading:true })
        if(!player_filter){ await dispatch(market_getPlayerFilterById(player_filter_id)) }
        await dispatch(market_getOrderByOrderId(order_id, true))
        setBetMatch({ ...bet_match_state, loading:false })
    }

    const runPlayerFilter = async(player_filter_id:string) => {
        setBetMatch({ ...bet_match_state, loading:true })
        if(!player_filter){ await dispatch(market_getPlayerFilterById(player_filter_id)) }
        await dispatch(market_runPlayerFilter(player_filter_id))
        setBetMatch({ ...bet_match_state, loading:false })
    }

    const handleToolbarSelect = async(action:string) => {
        if(!promoted_order){ return }
        switch(action){
            case 'all': return setBetMatch({ ...bet_match_state, promoted_order_index: 10000 });
            case 'skip': return setBetMatch({ ...bet_match_state, promoted_order_index: promoted_order_index + 1 })
            case 'decline': 
                if(!player){ return setBetMatch({ ...bet_match_state, promoted_order_index: promoted_order_index + 1 }) }
                let order_response:OrderResponseProps = {
                    bet_match_response_id: '',
                    order_id: promoted_order.order_id,
                    player_id: player.player_id,
                    be_type: 'new',
                    create_datetime: '',
                    last_update_datetime: '',
                    response: 'decline'
                }
                return await dispatch(market_saveOrderResponse(order_response))
            case 'accept': 
                setBetMatch({ ...bet_match_state, promoted_order_index: promoted_order_index + 1 })
                return dispatch(market_setDraftOrder({ ...promoted_order, order_type:'limit', open_amt: Math.round(promoted_order.open_amt * 100) / 100, buy_sell_ind: 'buy' }))
            case 'accept_partial': return dispatch(market_setDraftOrder({ ...promoted_order, buy_sell_ind: 'buy' }))
            default: return
        }
    }

    const handleThumnailSelect = (order:OrderProps) => {
        let index = filtered_orders.findIndex(o => o == order.order_id)
        setBetMatch({
            ...bet_match_state,
            promoted_order_index: index
        })
    }


    const renderOrders = (data: { item:string, index:number }) => {
        if(!player_filter){ return <></> }
        let order = orders.find(o => o.order_id == data.item)
        if(!order){ return <></> }
        return (
            <View key={order.order_id.toString()}>
                <PromotedOrderCard 
                    player_filter={player_filter}
                    order={order} 
                    height={app_size.height} 
                    width={app_size.width} 
                    onSelect={(order:OrderProps) => handleThumnailSelect(order)}/>
            </View>
        )
    }

    if(!player_filter){ return <></> }

    return (
        <View style={{flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }} onLayout={(ev) => {
                const { height } = ev.nativeEvent.layout
                setBetMatch({ ...bet_match_state, height })
            }}>
            <ImageBackground 
                source={{ uri : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1647289869/ellipse_background_fhh1ut.webp'}} 
                style={{ height: bet_match_state.height, width:app_size.width }}
            >
                    {player_filter && !promoted_order ?
                    <View nativeID='player_filter' style={{ padding:10 }}>
                        <Text size={20} color={Colors.brand.midnight} textAlign='center' weight='bold'>{player_filter.name}</Text>
                    </View>
                    :<></>}
                    {loading ?
                    <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                        <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                    </View>
                    :<></>}
                    <View style={{padding:20, flex:1, alignItems:'center'}}>
                        {promoted_order ?
                        <PromotedOrderCard 
                            height={bet_match_state.height - 50} 
                            width={app_size.width} 
                            featured order={promoted_order}
                            player_filter={player_filter}
                            />
                        : filtered_orders.length > 0 ?
                        <View style={{ flexDirection:'row', flexWrap:'wrap', justifyContent:'center'  }}>
                            {filtered_orders.map((o,i) => {
                                return renderOrders({item:o, index:i})
                            })}
                        </View>
                        : !loading ?
                        <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                            <TouchableOpacity style={{ ...localStyles.shadowBox, marginBottom:20, backgroundColor:Colors.shades.white, padding:10, margin:5, borderRadius:100, justifyContent:'center', alignItems:'center' }} onPress={() => runPlayerFilter(route.params.player_filter_id)}>
                                <Icon name='refresh-cw' type='feather' color={Colors.brand.midnight} size={20}/>
                            </TouchableOpacity>
                            <Text size={16} weight='bold' color={Colors.brand.midnight} textAlign='center'>Oh No! Looks like no orders match your search. Check back later!</Text>
                        </View>
                        :<></>
                        }
                    </View>
            </ImageBackground>
            
            </ScrollView>
            {!promoted_order && !loading && filtered_orders.length == 0 ?
            <View style={{paddingBottom:15, padding:10, borderRadius:4, backgroundColor:Colors.shades.shade600}}>
                <Text size={18} weight='semibold' color={Colors.brand.midnight} textAlign='center'>Feel like there should be orders showing up?</Text>
                <TouchableOpacity style={{ borderRadius:22, backgroundColor:Colors.brand.electric, padding:15, marginTop:10 }}
                onPress={() => navigation.push('ManageFilter', { player_filter_id: route.params.player_filter_id })}>
                    <Text size={14} color={Colors.shades.white} textAlign='center'>Manage This Filter</Text>
                </TouchableOpacity>
            </View>
            :<></>}
            {promoted_order ?
            <View style={{ flexDirection:'row', justifyContent:'center', marginBottom:15, marginTop:10 }}>
                <PromotedOrderToolbar height={app_size.height*0.075} onSelect={(action:string) => handleToolbarSelect(action)}/>
            </View>
            :<></>}
        </View>
    )
}

const localStyles = {
    shadowBox: { shadowColor: "rgba(0, 0, 0, 0.16)", shadowOffset: { width: 0, height: 3 }, shadowRadius: 12, shadowOpacity: 1, elevation:5  }
}

export default BetMatch